// Module Federation entry exposed as ./AppMount for hosts that import the remote directly.
import { loadAppSettings, setAppSettings } from './appSettings';
import { loadDesignSystem } from './designSystem';

const REQUIRED_SETTINGS = [
  'SHIPBOB_DESIGN_SYSTEM',
  'AUTHENTICATION_AUTHORITY',
  'CLIENT_ID',
  'CLIENT_SCOPE',
  'MFE_ROOT_ROUTE',
];

/** Loads settings, validates required keys (throws listing every missing one), then loads the design-system remote. */
export async function prepareRuntime(action) {
  const appSettings = await loadAppSettings();

  const missing = REQUIRED_SETTINGS.filter((key) => typeof appSettings[key] !== 'string' || !appSettings[key].trim());
  if (missing.length) {
    // Drop the cached (invalid) settings so the next mount refetches appsettings.json.
    // Without this, a parseable-but-incomplete file would wedge every subsequent mount
    // in this session — loadAppSettings() short-circuits on a truthy cache — even after
    // the file is fixed on the server.
    setAppSettings(null);
    throw new Error(
      `[order-shipment-management-ui] cannot ${action}: missing required app settings: ${missing.join(', ')}`,
    );
  }

  await loadDesignSystem(appSettings.SHIPBOB_DESIGN_SYSTEM);
}

/** MF entry: prepares runtime, then dynamic-imports the bootloader so it evaluates after the design system has loaded. */
export const mount = async (args = {}) => {
  await prepareRuntime('mount');
  const { mount: appMount } = await import('./bootloader');
  return appMount(args);
};
